module.exports = __webpack_public_path__ + "static/media/ModeloPadrãoMassaInicial.04514af1.csv";